module.exports = __webpack_public_path__ + "static/media/menu-library.798e089c.svg";